import SpriteAnim from '../../lib/spriteanim';

let anim = {

    requestIndex: 0,
    mergePics: [],
    parsedJson: [],

    play(container,  jsons, mergePics, onStart, onComplete) {
        let canvasDom = $('<canvas id="canvas1"></canvas>');
        // canvasDom.css({
        //     position: 'fixed',
        //     zIndex: 99999,
        //     left: 0,
        //     top: 0
        // });
        let wrap = container || $(document.body);
        
        wrap.append(canvasDom);

        this.asyncRequest(jsons, mergePics, (_jsons, _mergePics)=>{
            
            // 计算适配，canvas铺满全屏，自动居中，左右或者上下留白边，不裁切
            var frameWidth = 640;
            var frameHeight = 280;
            // var screenWidth = document.documentElement.clientWidth;
            // var screenHeight = document.documentElement.clientHeight;
            var offset = wrap.offset();
            var screenWidth = offset.width;
            var screenHeight = offset.height;
            var designRatio = frameHeight / frameWidth;
            var screenRatio = screenHeight / screenWidth;
            // 显示所有动画，左右或者上下留白边，不裁切
            var scale, offsetX, offsetY;

            if (screenRatio > designRatio) {
                scale = screenWidth / frameWidth;
                offsetX = 0;
                offsetY = (screenHeight - frameHeight * scale) / 2 / scale;
            } else {
                scale = screenWidth / frameWidth;
                offsetX = (screenWidth - frameWidth * scale) / 2 / scale;
                // offsetY = 0;
                offsetY = (screenHeight - frameHeight * scale) / scale;
            }

            let frames = [];
            _jsons.forEach((item, i)=>{
                if (mergePics[i]) {
                    let img = $('<img src="' + mergePics[i] + '" />')[0];
                    frames = [...frames, ...this.extractFrames(item, img)];
                }
            })
            // 按照名字排序，确保序列帧的播放顺序
            frames.sort(function (a, b) {
                return a.name < b.name ? -1 : 1;
            });

            var animation = new SpriteAnim("canvas1");
            
            animation.start({
                canvasWidth: screenWidth,
                canvasHeight: screenHeight,
                scale: scale,
                offsetX: offsetX,
                offsetY: offsetY,
                frames: frames,
                fps: 10,
                loop: true,
                onStart: function() {
                    if (typeof onStart == 'function') {
                        onStart();    
                    }
                    
                },
                onComplete: function() {
                    if (typeof onComplete == 'function') {
                        onComplete();    
                    }
                }
            });

        });
        
    },

    asyncRequest(jsons, mergePics, callback) {
        let len = jsons.length;

        if (this.mergePics.length == 0) {
            this.mergePics = mergePics;
        }

        if (jsons[this.requestIndex]) {
            $.ajax({
                url: 'https://proxy.upliveapps.com/index/index',
                data: {
                    requestSource: 1,
                    requestSourceUrl: jsons[this.requestIndex]
                },
                dataType: 'JSON'
            }).done((resp)=>{
                let _json;
                
                try {
                    // debugger
                    _json = JSON.parse(resp);
                    this.parsedJson.push(_json);
                } catch(e) {

                }
                this.requestIndex++;
                if (jsons[this.requestIndex]) {
                    this.asyncRequest(jsons, mergePics, callback);
                } else {
                    callback([...this.parsedJson], [...this.mergePics]);
                    this.requestIndex = 0;
                    this.parsedJson = [];
                    this.mergePics = [];
                }
            });
        }

    },

    extractFrames(jsonData, img) {

        var frames = [];
        var rawFrames = jsonData && jsonData.frames;
        if (rawFrames) {
            rawFrames.forEach(function(frameData) {

                frames.push({
                    name: frameData.filename,
                    image: img,
                    sx: frameData.frame.x,
                    sy: frameData.frame.y,
                    sWidth: frameData.frame.w,
                    sHeight: frameData.frame.h,
                    dx: frameData.spriteSourceSize.x,
                    dy: frameData.spriteSourceSize.y,
                    dWidth: frameData.spriteSourceSize.w,
                    dHeight: frameData.spriteSourceSize.h
                });
            });
        }
        return frames;
    }

};

export default anim;








// WEBPACK FOOTER //
// ./js/living/queueanim/index.js